import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Button, Row, Col, Tag } from 'antd';
import moment from 'moment';
import {
  FileTextOutlined,
  ClockCircleOutlined,
  PayCircleOutlined,
} from '@ant-design/icons';

const InvoicesTable = ({ invoices, onViewDetails, onViewPayments, onPay, role }) => {
  const { t } = useTranslation();
  
  const getTypeColor = (type) => {
    switch (type.toLowerCase()) {
      case 'prepaid':
        return '#28a745';
      case 'postpaid':
        return '#007bff';
      case 'monthly':
        return '#fd7e14';
      default:
        return 'black';
    }
  };

  const columns = [
    {
      title: t('subscriptions.paymentType'),
      dataIndex: ['subscription', 'paymentType'],
      key: 'paymentType',
      render: (paymentType) => (
        <Tag color={getTypeColor(paymentType)}>{paymentType.toUpperCase()}</Tag>
      ),
    },
    {
      title: t('subscriptions.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => moment(createdAt).format('DD.MM.YYYY HH:mm'),
    },
    {
      title: t('subscriptions.paidAt'),
      dataIndex: 'paidAt',
      key: 'paidAt',
      render: (paidAt) =>
        paidAt ? moment(paidAt).format('DD.MM.YYYY HH:mm') : '/',
    },
    {
      title: t('subscriptions.closedAt'),
      dataIndex: 'closedAt',
      key: 'closedAt',
      render: (closedAt) =>
        closedAt ? moment(closedAt).format('DD.MM.YYYY HH:mm') : '/',
    },
    {
      title: t('subscriptions.credits'),
      dataIndex: ['credits'],
      key: 'credits',
      render: (credits) => credits || 0,
    },
    {
      title: t('subscriptions.actions'),
      key: 'actions',
      render: (_, record) => {
        const isPostpaid = record.subscription?.paymentType === 'postpaid';
        const isUnpaid = !record.paidAt;
        const isPaymentEnabled = isPostpaid && isUnpaid && role === 'root';

        return (
          <Row gutter={8}>
            {record.payments.length > 0 && (
              <Col>
                <Button
                  icon={<ClockCircleOutlined />}
                  onClick={() => onViewPayments(record)}
                  style={{ marginRight: 8 }}
                >
                  {t('subscriptions.payments')}
                </Button>
              </Col>
            )}
            {isPaymentEnabled && (
              <Col>
                <Button
                  type="primary"
                  ghost
                  icon={<PayCircleOutlined />}
                  onClick={() => onPay(record)}
                >
                  {t('subscriptions.pay')}
                </Button>
              </Col>
            )}
            <Col>
              <Button
                icon={<FileTextOutlined />}
                onClick={() => onViewDetails(record)}
              >
                {t('subscriptions.details')}
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={invoices}
      pagination={false}
      rowKey="id"
    />
  );
};

export default InvoicesTable;
